// extracted by mini-css-extract-plugin
module.exports = {"dynamicSelect":"m-dynamic-select_dynamicSelect__HQGzZ","label":"m-dynamic-select_label__17n8W"};